module.exports = __webpack_public_path__ + "quest-ff9fafdee4e7eaac14101481f0257ed3.jpg";